import React, { useState, useEffect, useRef } from "react";
import { Modal, Input, Typography, Table, Row, Button, Col } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useTranslation } from "react-i18next";

import moment from "moment";

const { Text } = Typography;
const NotesModal = ({ notes = [], title, isVisible, setIsVisible, promiseResolve }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(notes);
  const [newNote, setNewNote] = useState("");

  useEffect(() => {
    if (isVisible) {
      setValue(notes);
      setNewNote("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  const handleOk = () => {
    setIsVisible(false);
    promiseResolve(value);
  };

  const handleCancel = () => {
    setIsVisible(false);

    promiseResolve();
  };

  const handleAddNote = () => {
    setValue([{ date: new Date(), content: newNote }, ...value]);
    setNewNote("");
  };

  const columns = [
    {
      title: t("date"),
      dataIndex: "date",
      key: "date",
      width: "20%",
      render: (text, record) => (
        <Text>{moment(record.date).tz("Europe/Paris").format("DD/MM/YY HH:mm")}</Text>
      ),
    },
    {
      title: t("note"),
      dataIndex: "content",
      key: "content",
      render: (text, record) => <Text>{record.content}</Text>,
    },
  ];

  return (
    <Modal
      open={isVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      title={title}
      width={"75vw"}
      bodyStyle={{ height: "70vh" }}
      footer={[
        <Button key="back" onClick={handleCancel} style={{ width: "250px" }}>
          {t("Cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} style={{ width: "250px" }}>
          {t("Save")}
        </Button>,
      ]}
    >
      <Row style={{ height: "80%" }}>
        <Col span={24}>
          <Table style={{ width: "70vw" }} columns={columns} dataSource={value} pagination={true} />
        </Col>
      </Row>
      <Row style={{ height: "20%" }}>
        <Col offset={2} span={17} style={{ display: "flex", flexDirection: "column" }}>
          <Text>{t("NewNote")}</Text>
          <TextArea
            autoSize={{
              minRows: 4,
              maxRows: 6,
            }}
            value={newNote}
            onChange={e => setNewNote(e.target.value)}
          />
        </Col>
        <Col
          offset={1}
          span={3}
          style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          <Button
            type="secondary"
            onClick={handleAddNote}
            style={{ width: "250px" }}
            disabled={newNote.length === 0}
          >
            {t("Add")}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default NotesModal;

export const useNotesModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [promiseResolve, setPromiseResolve] = useState(null);
  const [value, setValue] = useState([]);
  const [title, setTitle] = useState("");

  const updateNotes = (title, value) => {
    setIsVisible(true);
    setTitle(title);
    setValue(value);

    return new Promise(resolve => {
      setPromiseResolve(() => resolve);
    });
  };

  return [
    updateNotes,
    <NotesModal
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      promiseResolve={promiseResolve}
      notes={value}
      title={title}
    />,
  ];
};
